import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

const STANDARDS_COLORS = ['secondary', 'primary', 'success', 'error', 'warning', 'info'] as const;

@Component({
  selector: 'status-card',

  imports: [NgTemplateOutlet],
  templateUrl: './status-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './status-card.component.scss',
})
export class StatusCardComponent implements OnInit {
  public label = input<string>();
  public value = input<number | null>(null);
  public percentage = input<number | null>(null);
  public color = input<string | typeof STANDARDS_COLORS>('primary');
  public selected = input<boolean>(false);

  @Output() onClick = new EventEmitter<void>();

  public roundedPercentage = computed(() => Math.round(this.percentage()));
  public computedColor = computed(() => this.computeColor());

  public isClickEventListened: boolean = false;

  public ngOnInit() {
    this.isClickEventListened = !!this.onClick.observers.length;
  }

  public handleClick() {
    this.onClick.emit();
  }

  private computeColor() {
    const isStandardColor = STANDARDS_COLORS.includes(this.color() as any);
    if (isStandardColor) {
      return `var(--background-${this.color()})`;
    } else {
      return this.color();
    }
  }
}
